package dev.danko.roblox_craft_ai.shared.repository

import dev.danko.roblox_craft_ai.shared.model.PromptPresetDto
import kotlinx.browser.localStorage
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val STORAGE_KEY = "robloxCraft.personalPresets.v1"
private const val MAX_PRESETS = 50

private val LocalJson = Json {
    ignoreUnknownKeys = true
    encodeDefaults = true
}

class PersonalPresetRepositoryJs : PersonalPresetRepository {
    override suspend fun getAll(): List<PromptPresetDto> {
        return try {
            val raw = localStorage.getItem(STORAGE_KEY) ?: return emptyList()
            if (raw.isBlank()) return emptyList()
            LocalJson.decodeFromString<List<PromptPresetDto>>(raw)
        } catch (_: Throwable) {
            emptyList()
        }
    }

    override suspend fun add(preset: PromptPresetDto): Result<PromptPresetDto> {
        val current = getAll()
        if (current.size >= MAX_PRESETS) {
            return Result.failure(IllegalStateException("Максимум 50 персональных промптов. Удалите старые."))
        }
        val updated = current + preset
        return try {
            localStorage.setItem(STORAGE_KEY, LocalJson.encodeToString(updated))
            Result.success(preset)
        } catch (t: Throwable) {
            Result.failure(t)
        }
    }

    override suspend fun delete(id: String): Boolean {
        val current = getAll()
        val target = current.firstOrNull { it.id == id } ?: return false
        val updated = current.filter { it.id != id }
        return try {
            localStorage.setItem(STORAGE_KEY, LocalJson.encodeToString(updated))
            true
        } catch (_: Throwable) {
            false
        }
    }

    override suspend fun count(): Int {
        return getAll().size
    }
}
